module.exports = __webpack_public_path__ + "static/media/profile-picture.e19e0465.jpg";